export class SectorStatusDTO {

    id?: number;
    name: string;
} 